import { render, staticRenderFns } from "./StudentPosterAdmin.vue?vue&type=template&id=01904d0b&scoped=true&"
import script from "./StudentPosterAdmin.vue?vue&type=script&lang=js&"
export * from "./StudentPosterAdmin.vue?vue&type=script&lang=js&"
import style0 from "./StudentPosterAdmin.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StudentPosterAdmin.vue?vue&type=style&index=1&id=01904d0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01904d0b",
  null
  
)

export default component.exports